import type { ConstructorPlan } from './constructorTypes'
import { isAiComposedPlan } from './constructorPlanVisibility'

export function PlanCard({ plan, selected, onClick }: { plan: ConstructorPlan; selected: boolean; onClick: () => void }) {
  const statusDotColors: Record<string, string> = {
    active: 'bg-emerald-500',
    completed: 'bg-blue-500',
    archived: 'bg-slate-400',
  }
  const status = plan.status ?? 'active'
  const dateValue = plan.plan_date ?? plan.created_at
  const dateLabel = dateValue ? new Date(dateValue).toLocaleDateString('ru-RU') : '—'
  const title = plan.title?.trim() ? plan.title : `План от ${dateLabel}`

  return (
    <button
      type="button"
      className={`flex w-full items-start gap-2 border-l-2 px-2 py-1.5 text-left transition-colors ${
        selected
          ? 'border-l-blue-500 bg-blue-50'
          : 'border-l-transparent bg-white hover:bg-slate-50'
      }`}
      onClick={onClick}
    >
      <span className={`mt-1.5 h-2 w-2 flex-shrink-0 rounded-full ${statusDotColors[status] ?? statusDotColors.active}`} />
      <div className="min-w-0 flex-1">
        <div className="mb-0.5 flex items-center gap-1.5">
          {isAiComposedPlan(plan) ? (
            <span className="rounded-full border border-violet-200 bg-violet-50 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-violet-700">
              ИИ
            </span>
          ) : null}
        </div>
        <p className={`truncate text-[12px] font-semibold ${selected ? 'text-blue-700' : 'text-slate-800'}`}>{title}</p>
        <p className="truncate text-[11px] text-slate-500">{plan.patient_name || 'Пациент не указан'}</p>
        <p className="truncate text-[10px] text-slate-500">
          Врач: <span className="font-medium text-slate-600">{plan.doctor_name || 'не выбран'}</span>
        </p>
        <div className="mt-0.5 flex items-center gap-2 text-[10px] text-slate-400">
          <span>{dateLabel}</span>
          {plan.total_amount !== undefined && plan.total_amount > 0 ? (
            <span className="font-medium text-slate-600">
              · {Number(plan.total_amount).toLocaleString('ru-RU')} ₽
            </span>
          ) : null}
        </div>
        <div className="mt-1 flex flex-wrap items-center gap-1.5 text-[10px]">
          {plan.offer_deadline ? (
            <span className="rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 font-medium text-amber-700">
              Цена до {new Date(plan.offer_deadline).toLocaleDateString('ru-RU')}
            </span>
          ) : null}
          <span className="rounded-full border border-violet-200 bg-violet-50 px-2 py-0.5 font-medium text-violet-700">
            Аналитика: {plan.analytics?.view_count ?? 0}
          </span>
        </div>
      </div>
    </button>
  )
}
